"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Farm_1 = __importDefault(require("@becrop/components/ClientFarmListView/modules/models/Farm"));
const FieldsAnalyticsService_1 = __importDefault(require("../services/FieldsAnalyticsService"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
class FarmAnalytics extends Farm_1.default {
    constructor(farmDefaultData, breakdownRecommendations, breakdownNeeds, breakdownMetrics, breakdownPHCH, fieldsAnalytics, crops, projectID, rate) {
        super(farmDefaultData);
        this.serviceFields = new FieldsAnalyticsService_1.default();
        this.breakdownRecommendations = breakdownRecommendations;
        this.breakdownNeeds = breakdownNeeds;
        this.breakdownMetrics = breakdownMetrics;
        this.breakdownPHCH = breakdownPHCH;
        this.fieldsAnalytics = fieldsAnalytics;
        this.cropsAnalytics = crops;
        this.acreageByFarm = new Acreage_1.default(farmDefaultData.total_extension, farmDefaultData.preferred_unit);
        this.loading = false;
        this.projectID = projectID;
        this.rate = rate;
        this.loadingAllPagesFields = false;
    }
    async getFields() {
        try {
            this.loading = true;
            this.loadingAllPagesFields = true;
            const pageSize = 30;
            this.fieldsAnalytics = [];
            const firstPageFields = await this.serviceFields.getFields(this.id, this.gis_area_id, 1);
            this.fieldsAnalytics.push(...firstPageFields);
            const totalFarms = this.serviceFields.totalElements || 0;
            const totalPages = Math.ceil(totalFarms / pageSize);
            this.loading = false;
            for (let page = 2; page <= totalPages; page++) {
                const fields = await this.serviceFields.getFields(this.id, this.gis_area_id, page);
                this.fieldsAnalytics.push(...fields);
            }
            this.loadingAllPagesFields = false;
            return this.fieldsAnalytics;
        }
        catch (error) {
            console.error("Failed to load fields analytics:", error);
        }
    }
    addField(field) {
        this.fieldsAnalytics.push(field);
    }
    removeField(fieldId) {
        this.fieldsAnalytics = this.fieldsAnalytics.filter(field => field.id !== fieldId);
    }
    updateFieldAnalytics(updatedField) {
        const fieldToUpdate = this.fieldsAnalytics.find(field => field.name === updatedField.name);
        if (fieldToUpdate) {
            Object.assign(fieldToUpdate, updatedField);
        }
        else {
            console.log(`Field with name ${updatedField.name} not found.`);
        }
    }
    searchFieldByName(keyword) {
        const lowerKeyword = keyword.toLowerCase();
        return this.fieldsAnalytics.filter(field => field.name.toLowerCase().includes(lowerKeyword));
    }
    get getAllUniqueRecommendations() {
        const recommendationsSet = new Set();
        this.fieldsAnalytics.forEach(field => {
            field.breakdownRecommendations.forEach(rec => {
                recommendationsSet.add(rec.name);
            });
        });
        return Array.from(recommendationsSet);
    }
    get getAllUniqueNeeds() {
        const needsSet = new Set();
        this.fieldsAnalytics.forEach(field => {
            field.breakdownNeeds.forEach(need => {
                needsSet.add(need.name);
            });
        });
        return Array.from(needsSet);
    }
    get getUniquePhchNames() {
        const uniqueSet = new Set();
        const result = [];
        for (const item of this.breakdownPHCH || []) {
            const key = `${item.name}__${item.unit}`;
            if (!uniqueSet.has(key)) {
                uniqueSet.add(key);
                result.push({ name: item.name, unit: item.unit });
            }
        }
        console.log(result, 'phch');
        return result;
    }
    getAllMetricsFromField(fieldId) {
        const field = this.fieldsAnalytics.find(f => f.id === fieldId);
        if (!field) {
            console.warn(`Field with ID ${fieldId} not found.`);
            return [];
        }
        const metrics = [];
        field.breakdownMetrics.forEach((category) => {
            category.metrics.forEach((metric) => {
                metrics.push(metric);
            });
        });
        return metrics;
    }
    get getUniqueMetricNames() {
        const metricNameSet = new Set();
        this.breakdownMetrics.forEach((category) => {
            category.metrics.forEach((metric) => {
                metricNameSet.add(metric.name);
            });
        });
        return Array.from(metricNameSet);
    }
    get getAllMetricsFromFarm() {
        const metrics = [];
        this.breakdownMetrics.forEach((category) => {
            category.metrics.forEach((metric) => {
                metrics.push(metric);
            });
        });
        return metrics;
    }
}
exports.default = FarmAnalytics;
